import React, { useState } from 'react';
import { Box, Typography, IconButton } from '@mui/material';
import { Close as CloseIcon, Email as EmailIcon } from '@mui/icons-material';
import { useAuth } from '../contexts/AuthContext';
import { API_BASE_URL } from '../services/api';

const EmailVerificationBanner: React.FC = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(false);
  const [resending, setResending] = useState(false);
  const [resent, setResent] = useState(false);

  // Don't show if verified, dismissed, OAuth user, or no user
  if (!user || user.isEmailVerified || user.authProvider !== 'local' || dismissed) return null;

  // Don't show if already dismissed this session
  if (sessionStorage.getItem('emailBannerDismissed')) return null;

  const handleResend = async () => {
    setResending(true);
    try {
      const token = localStorage.getItem('token');
      await fetch(`${API_BASE_URL}/auth/resend-verification`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` },
      });
      setResent(true);
    } catch {} finally {
      setResending(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('emailBannerDismissed', 'true');
  };

  return (
    <Box sx={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      gap: 1, py: 0.75, px: 2,
      background: 'linear-gradient(90deg, rgba(0,224,255,0.1), rgba(0,224,255,0.05))',
      borderBottom: '1px solid rgba(0,224,255,0.2)',
    }}>
      <EmailIcon sx={{ fontSize: 16, color: '#00E0FF' }} />
      <Typography sx={{ fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: 'rgba(255,255,255,0.7)' }}>
        {resent ? 'Verification email sent! Check your inbox.' : 'Please verify your email.'}
      </Typography>
      {!resent && (
        <Typography
          onClick={handleResend}
          sx={{
            fontFamily: 'var(--font-mono)', fontSize: '0.7rem', color: '#00E0FF',
            cursor: 'pointer', fontWeight: 600,
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {resending ? 'Sending...' : 'Resend'}
        </Typography>
      )}
      <IconButton onClick={handleDismiss} size="small" sx={{ color: 'rgba(255,255,255,0.5)', p: 0.25 }}>
        <CloseIcon sx={{ fontSize: 14 }} />
      </IconButton>
    </Box>
  );
};

export default EmailVerificationBanner;
